<template>
	<section id="assets" class="marketing-section bg-color-white">
		<div class="container">
			<div class="text-align-center mb-200 pt-100">
				<h2 class="heading-2">Portfolio companies</h2>
				<p class="col-8-md col-offset-2-md"
					>The Fund is actively investing and has built a portfolio that includes some of the top Artificial
					Intelligence, Machine Learning, and Data Infrastructure companies in the world.</p
				>
			</div>
			<AssetElementContainer
				:asset-elements="props.assetElements"
				:asset-elements-per-page="12"
				:filter-options="filterOptions"
				:show-assets-heading="false"
				:show-disclaimer-if-applicable="false"
				:use-grid="true"
				:use-large-cards="true"
			/>
		</div>
	</section>
</template>

<script setup lang="ts">
import { computed, nextTick, ref, watch } from 'vue';
import { Asset } from 'types/assets';
import AssetElementContainer from '@components/asset-element/asset-element-container.vue';
import { CompaniesFilterOptions } from 'types/asset-details';
import { getRouteHash } from '@utils/routing';
import { scrollToAnchor } from '@utils/scroll-to';
import { useRoute } from 'vue-router';

interface Props {
	assetElements?: Array<Asset>;
}

const props = withDefaults(defineProps<Props>(), {
	assetElements: () => []
});

const route = useRoute();

const industryTypes = ref<Array<string>>([]);
const assetTypeTypes = ref<Array<string>>([]);

const filterOptions = computed((): Array<CompaniesFilterOptions> => {
	return [
		{
			filterClass: 'industry',
			filterClassLabel: 'Industry',
			filterType: industryTypes.value
		},
		{
			filterClass: 'assetType',
			filterClassLabel: 'Asset type',
			filterType: assetTypeTypes.value
		}
	];
});

const routeHash = computed((): string => getRouteHash(route));

watch(
	() => routeHash.value,
	(anchor: string): void => {
		if (anchor) {
			nextTick(() => scrollToAnchor(anchor));
		}
	},
	{ immediate: true }
);

function initializeFilterSelections(): void {
	props.assetElements.forEach((element) => {
		if (!assetTypeTypes.value.includes(element.assetType.name)) {
			assetTypeTypes.value.push(element.assetType.name);
		}
		if (
			element.ventureCapitalFields?.industry &&
			!industryTypes.value.includes(element.ventureCapitalFields.industry.name)
		) {
			industryTypes.value.push(element.ventureCapitalFields.industry.name);
		}
	});
}

function setup(): void {
	initializeFilterSelections();
}

setup();
</script>
